<template>
  <button  @click="clicked" :type="type"
           :class="getCss"
           :disabled="disabled"
  >
    {{label}}
    <slot name="any"></slot>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    label: {
      default: '',
    },
    type: {
      type: String,
      default: 'button',
    },
    variant: {
      type: String,
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getCss() {
      let style = `text-sm mx-2 focus:outline-none flex justify-center px-4 py-2 rounded font-bold
      cursor-pointer border transition border duration-200 ease-in-out relative `;
      switch (this.variant) {
        case 'primary':
          style += 'hover:bg-blue-100 hover:text-blue-700 bg-blue-700 text-blue-100 border-blue-600 ';
          break;
        case 'default':
          style += 'bg-gray-700 text-gray-100 hover:bg-gray-100 hover:text-gray-700 border-gray-600 ';
          break;
        case 'outline-primary':
          style += 'hover:bg-blue-700 hover:text-blue-100 text-blue-700 text-blue-700 border-blue-600 ';
          break;
        default:
          style += 'hover:bg-blue-100 hover:text-blue-700 bg-blue-700 text-blue-100 border-blue-600 ';
          break;
      }
      return style;
    },
  },
  methods: {
    clicked() {
      this.$emit('clicked');
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Layout/Form/Button.vue